var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCameraOff(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M1.82576 6.5657L1.87868 6.62132L3.26355 8.00697C3.11916 8.25892 3.02802 8.54529 3.00549 8.85074L3 9V18C3 19.0544 3.81588 19.9182 4.85074 19.9945L5 20H15.257L17.257 22H5C2.8578 22 1.10892 20.316 1.0049 18.1996L1 18V9C1 8.08405 1.30787 7.24 1.82576 6.5657ZM14.9296 2C15.8658 2 16.7442 2.43669 17.3095 3.17347L17.4258 3.3359L18.535 5H19C21.0731 5 22.7778 6.57708 22.9799 8.59694L22.9951 8.80036L23 9V18C23 18.4713 22.9185 18.9235 22.7688 19.3433C22.6467 19.0504 22.4758 18.7727 22.2563 18.5227L22.1213 18.3787L21 17.257V9C21 7.94564 20.1841 7.08183 19.1493 7.00549L19 7H17.4648L15.7617 4.4453C15.5762 4.1671 15.264 4 14.9296 4H9.07037C8.77781 4 8.50219 4.12794 8.3136 4.34629L8.23832 4.4453L8.218 4.475L6.79175 3.04856C7.27188 2.48782 7.94254 2.12383 8.67343 2.02634L8.87073 2.00663L9.07037 2H14.9296ZM6.61801 11.3614L8.60345 13.3481C8.91496 14.5998 9.90025 15.585 11.1519 15.8966L13.1386 17.882C12.7713 17.9593 12.3904 18 12 18C8.96243 18 6.5 15.5376 6.5 12.5C6.5 12.1096 6.54067 11.7287 6.61801 11.3614ZM12 7C15.0376 7 17.5 9.46243 17.5 12.5C17.5 12.8904 17.4593 13.2713 17.382 13.6386L15.3966 11.6519C15.085 10.4002 14.0998 9.41496 12.8481 9.10345L10.8614 7.11801C11.2287 7.04067 11.6096 7 12 7Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M20 20.5L4 4.5",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCameraOff);
export default __webpack_public_path__ + "static/media/camera-off.70a32bc2.svg";
export { ForwardRef as ReactComponent };